import CityPageTemplate from "../city-template/CityPageTemplate";
import { nashuaConfig } from "./data";

export default function NashuaPage() {
  return <CityPageTemplate config={nashuaConfig} />;
}